import { Box, Typography } from '@mui/material'
import { FC } from 'react'
import { fadeSlideIn } from './animations'

export const PlatformStat: FC<{
  value: number
  label: string
  accent: string
  delay: number
}> = ({ value, label, accent, delay }) => (
  <Box
    sx={{
      animation: `${fadeSlideIn} 0.4s ease-out ${delay}ms both`,
      textAlign: 'center',
      py: 2,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    }}
  >
    <Typography
      sx={{
        fontSize: 36,
        fontWeight: 700,
        lineHeight: 1,
        letterSpacing: '-0.03em',
        color: accent,
        fontVariantNumeric: 'tabular-nums', mb: 0.5 }}>
      {value}
    </Typography>
    <Typography
      sx={{
        fontSize: 11,
        fontWeight: 600,
        color: 'rgba(0,0,0,0.35)',
        textTransform: 'uppercase',
        letterSpacing: '0.08em',
      }}
    >
      {label}
    </Typography>
  </Box>
)
